import React from 'react';
import {Row, Col} from 'react-bootstrap';
import ItemCard from '../../containers/common/ItemCard.js';

class StoreItemsList extends React.Component {
    getComponentsPerRow = (subArray, itemsList, itemsInRow, startIndex) => {
      return (
          <Row key={startIndex}>
              {
                  subArray.map(key => {
                      return (
                          <Col className="item-card-wrapper" key={key} xs={12/itemsInRow}>
                              <ItemCard item={itemsList[key]} key={key} selectedItem={this.props.itemKey} staticData = {this.props.staticData}/>
                          </Col>
                      )
                  })
              }
          </Row>
      )
    };

    renderByCategory = (itemsList, itemsInRow) => {
        let categories = {};
        this.props.categories.map(category => {
            categories[category.key] = {items: [], title: category.title, key: category.key};
        });
        for (let key in itemsList) {
            if (itemsList.hasOwnProperty(key)) {
                const item = itemsList[key];
                if (!item.variation && (this.props.staticData.showUnavailableItemsInStore || item.available > 0)) {
                    categories[item.category].items.push(Object.assign({}, item));
                }
            }
        }
        return Object.values(categories).filter(category => category.items.length > 0).map(category => {
            return [
                <Col className="item-card-wrapper" key={category.key} xs={12/itemsInRow}>{category.title}</Col>,
                this.renderItems(category.items, itemsInRow, 'i-' + category.key)
            ];
        });
    };

    renderItems = (itemsList, itemsInRow, category = 'items') => {
        const keys = Object.keys(itemsList);
        return (
            <div className="items" id="items" key={category}>
                {keys.map((key, index) => {
                    if(index % itemsInRow === 0){
                        const subKeysArray = keys.slice(index, index+itemsInRow);
                        return this.getComponentsPerRow(subKeysArray, itemsList, itemsInRow, index);
                    }
                })}
            </div>
        )
    };

    render() {
        const itemsInRow = this.props.itemsInRow;
        const itemsList = this.props.itemsList;
        if (this.props.categories) {
            return this.renderByCategory(itemsList, itemsInRow);
        }
        return this.renderItems(itemsList, itemsInRow);
    }
}

export default StoreItemsList;


// WEBPACK FOOTER //
// ./src/components/store/StoreItemsList.js